import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politicas-privacidad-rentascr',
  templateUrl: './politicas-privacidad-rentascr.component.html',
  styleUrls: ['./politicas-privacidad-rentascr.component.scss']
})
export class PoliticasPrivacidadRentascrComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    window.scrollTo(0, 0);
  }
}
